import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

type Props = {
  endpoint: string;
  apiKey: string;
};

const DeploymentCallApi = (props: Props) => {
  const { endpoint, apiKey } = props;
  return (
    <div>
      {/* <p className="mb-1 text-lg">Call endpoint</p> */}
      <p className="text-base">Send a request</p>
      <p className="text-muted-foreground">
        Now that your project is running on float16, you can make a request using these
        client.
      </p>
      <div className="mt-2">
        <Tabs defaultValue="curl" className="w-full">
          <TabsList className="" variant={'outline'}>
            <TabsTrigger value="curl" variant={'outline'}>
              cURL
            </TabsTrigger>
          </TabsList>
          <TabsContent value="curl">
            <div className="">
              <SyntaxHighlighter language="bash" showCopy wrapLines>
                {`curl -X POST ${endpoint} \\
    -H 'Authorization: Bearer ${apiKey}' \\
    -H 'Content-Type: application/json' \\
    -d '{}'`}
              </SyntaxHighlighter>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default DeploymentCallApi;
